import { Group, Text } from '@mantine/core';
import { IconAsterisk } from '@tabler/icons-react';
import { TaskBadge } from 'components/TaskBadge';
import { tKeys, useTranslation } from 'locales/index';
import type { Task } from 'shared/hooks/use-load-tasks';
import { EditableAssigneeBadge } from './EditableAssigneeBadge';
import { EditableDueDateBadge } from './EditableDueDateBadge';
import { EditableTypeBadge } from './EditableTypeBadge';

type TaskBadgesProps = {
  task: Task;
};

export const TaskBadges = ({ task }: TaskBadgesProps) => {
  const { t } = useTranslation();

  return (
    <Group gap={8}>
      {task.mandatory && (
        <TaskBadge variant="light" icon={<IconAsterisk size={14} />} color="orange">
          <Text size="sm">{t(tKeys.MANDATORY)}</Text>
        </TaskBadge>
      )}
      {task.type && <EditableTypeBadge task={task} />}
      {task.assignee?.first_name && <EditableAssigneeBadge task={task} />}
      {task.due_date && <EditableDueDateBadge task={task} />}
    </Group>
  );
};
